import { CANONICAL_ORIGIN } from "@shared/seo-constants";

export const BASE_URL = CANONICAL_ORIGIN;

export function canonicalUrlFor(path: string): string {
  return `${BASE_URL}${path === "/" ? "" : path.replace(/\/$/, "")}`;
}
